import { Injectable, Inject, PLATFORM_ID, inject, effect } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AppTheme } from '../models';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private userService = inject(UserService);

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    effect(() => {
      const profile = this.userService.userProfile();
      if (profile?.theme) {
        this.apply(profile.theme as AppTheme);
      }
    });
  }

  apply(theme: AppTheme): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const html = document.documentElement;

    if (theme === 'auto') {
      const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
      html.classList.toggle('dark', prefersDark);
    } else {
      html.classList.toggle('dark', theme === 'dark');
    }

    localStorage.setItem('theme', theme);
  }

  applyFromStorage(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const saved = localStorage.getItem('theme') as AppTheme | null;
    this.apply(saved ?? 'auto');
  }

  applyFromProfile(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const profile = this.userService.getCurrentUser();
    const theme = (profile?.theme as AppTheme) ?? 'auto';
    this.apply(theme);
  }

  watchSystemTheme(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', () => {
        const saved = localStorage.getItem('theme') as AppTheme | null;
        if (!saved || saved === 'auto') this.apply('auto');
      });
  }
}
